<template>
  <section class="update_password-screen">
    <el-col :md="12" :lg="10" :sm="24" :xs="24" :xl="10" class="login-screens-right">
      <section class="update_password-form">
        <div class="mobile-logo hidden-md-and-up">
          <div class="logo text-center">
            <router-link to="/">
              <img src="/img/login-screens/Logo.png" alt="nurton logo"/>
            </router-link>
          </div>
        </div>
        <h3 class="form-title">Update Password</h3>
        <el-form ref="form" :model="password_form" class="login-forms">
          <el-row>
            <el-col :md="24">
              <el-form-item label="Current Password">
                <el-input v-model="password_form.current_password"
                          placeholder="Current Password" show-password></el-input>
                <span
                  class="error"
                  v-if="getErrors && getErrors['current_password']"
                >{{ this.getErrors['current_password'] }}</span>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-form-item label="New Password">
                <el-input v-model="password_form.password" placeholder="New Password"
                          show-password></el-input>
                <span
                  class="error"
                  v-if="getErrors && getErrors['password']"
                >{{ this.getErrors['password'] }}</span>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-form-item class="mb-0" label="Confirm New Password">
                <el-input
                  v-model="password_form.password_confirmation"
                  placeholder="Confirm New Password" show-password
                ></el-input>
                <span
                  class="error"
                  v-if="getErrors && getErrors['password_confirmation']"
                >{{ this.getErrors['password_confirmation'] }}</span>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <div class="password_form forgot-password"></div>
            </el-col>
            <el-col :md="24">
              <el-form-item>
                <el-button
                  type="primary"
                  :loading="loading"
                  @click="onSubmit"
                  class="btn submit-btn"
                >Update
                </el-button>
                <div class="form-navigation">
                  <router-link class="text-white" :to="{ name: 'profile' }">Back to profile details.</router-link>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="mobile-copyright hidden-md-and-up">
          <el-row>
            <el-col :xl="24">
              <p>
                Copyright © 2019
              </p>
            </el-col>
            <el-col :xl="24">
              <p>
                Powered by
                <a href="https://orotron.com/" target="_blank">OROTRON</a>
              </p>
            </el-col>
            <p class="error" v-if="getErrors && getErrors['error']">{{ this.getErrors['error'] }}</p>
          </el-row>
        </div>
      </section>
    </el-col>
  </section>
</template>

<script>
import {mapGetters} from "vuex";
import AuthenticationLayout from "../../layouts/AuthenticationLayout.vue";

export default {
  data() {
    return {
      loading: false,
      password_form: {
        current_password: "",
        password: "",
        password_confirmation: ""
      }
    };
  },
  computed: {
    ...mapGetters("errors", ["getErrors", "getMessage"]),
  },
  created() {
    this.$emit("update:layout", AuthenticationLayout);
    this.$root.$emit('closenav', false);
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      await this.$store.dispatch("profile/updatePassword", this.password_form);
      this.loading = false;
      if (this.getMessage) {
        this.$message.success(this.getMessage);
        await this.$router.push({name: "signin"});
      }

    }
  }
};
</script>

<style scoped lang="scss">
</style>
